import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router, ActivatedRoute, NavigationEnd, Scroll } from "@angular/router";
import { filter, map, tap } from "rxjs";

@Component({
  selector: "app-multi-page-container",
  standalone: false,
  templateUrl: "./multi-page-container.component.html",
  styleUrl: "./multi-page-container.component.scss",
})
export class MultiPageContainerComponent implements OnInit {
  private _router = inject(Router);

  private _route = inject(ActivatedRoute);

  private _destroyRef = inject(DestroyRef);

  state = toSignal(
    this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd || event instanceof Scroll),
      map(() => {
        const lookup = {
          ["amdt"]: "AIP Amandment Request",
          ["sup"]: "AIP Supplement Request",
          ["notam"]: "NOTAM Request",
          ["aic"]: "AIC Request",
        };
        const childRouteData = this._route.snapshot.firstChild.data?.step;
        const aisProduct = this._route.snapshot.firstChild.params?.aisProduct;
        const stepLookup = {
          1: {
            step: childRouteData,
            title: "Which AIS product would you like to request?",
          },
          2: {
            step: childRouteData,
            title: lookup[aisProduct],
          },
        };
        return stepLookup[childRouteData];
      })
    )
  );

  constructor() {}

  ngOnInit(): void {}

  goBack(): void {
    const targetStep = this.state().step - 1;
    const routes = this._route.routeConfig.children.filter((route) => !!route.path);
    const targetRoute = routes[targetStep - 1];
    console.log(targetRoute);
    this._router.navigate([targetRoute.path], { relativeTo: this._route });
  }
}
